/**
 * Which viewer owns the keyboard: the Configurator (3D editor), the Navigator
 * (pixel streaming) or another tab.
 *
 * Scene.tsx keeps the answer in its `viewerInFocus` state and hands it to
 * every tab. FlexLayout only updates it when a tab *header* is clicked — a
 * click into a tab's content never reaches it — so the viewers announce a
 * click into their content themselves through this event, and the Navigator
 * also claims the keyboard the moment its scene has loaded.
 */

export const VIEWER_FOCUS_EVENT = "hegias:viewerFocus";

/** Tab ids from Scene.tsx's tab table that can own the keyboard. */
export const VIEWER_FOCUS_CONFIGURATOR = "sceneView";
export const VIEWER_FOCUS_NAVIGATOR = "pstreaming";

export const requestViewerFocus = (viewerId: string) => {
	window.dispatchEvent(
		new CustomEvent<string>(VIEWER_FOCUS_EVENT, { detail: viewerId }),
	);
};
